module.exports = __webpack_public_path__ + "img/google.302a6457.svg";